import { NO_DATA } from 'helper/constants';
import type { DeviationWithVIN } from 'helper/types';
import { memo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    clearSelectedVehicle,
    getSelectedVehicle,
    setFollowSelectedVehicle,
    setIsFullMissionRouteVisible,
    setSelectedVehicle,
} from 'store/slices/appSlice';

import type { PrioritezedItem } from './types';
import VehicleDeviationCard from './VehicleDeviationCard';

export interface DeviationWithRelativeTime extends DeviationWithVIN {
    relativeTime: string;
}

interface Props {
    vehicle: PrioritezedItem;
    className?: string;
}

const PrioritizedListItem = ({ vehicle, className }: Props) => {
    const dispatch = useDispatch();
    const selectedVehicleState = useSelector(getSelectedVehicle);
    const selectedVIN = selectedVehicleState?.selectedVIN;

    const isSelected = selectedVIN === vehicle?.vin;
    const vehicleIdentifier = vehicle.name ?? vehicle.licensePlate ?? vehicle.vin ?? NO_DATA;
    const vehicleHasMission = !!vehicle?.missionId;

    const handleClick = useCallback(() => {
        if (isSelected) {
            dispatch(clearSelectedVehicle());
            dispatch(setIsFullMissionRouteVisible(false));
        } else {
            if (vehicleHasMission) {
                dispatch(setSelectedVehicle({ selectedVIN: vehicle.vin, pvlTriggered: true }));
                dispatch(setFollowSelectedVehicle(false));
                dispatch(setIsFullMissionRouteVisible(true));
            } else {
                dispatch(setSelectedVehicle({ selectedVIN: vehicle.vin, pvlTriggered: true }));
                dispatch(setIsFullMissionRouteVisible(false));
                dispatch(setFollowSelectedVehicle(true));
            }
        }
    }, [dispatch, isSelected, vehicleHasMission, vehicle.vin]);

    return (
        <VehicleDeviationCard
            vehicle={vehicle}
            onClick={handleClick}
            vehicleIdentifier={vehicleIdentifier}
            isSelected={isSelected}
            className={className}
            mrmState={vehicle?.mrmState}
            connectivityState={vehicle?.connectivityState}
        />
    );
};

export default memo(PrioritizedListItem);
